// CHANGELOG.js
// Export changelog text to reuse in App.js

export const CHANGELOG = `
🗣️ 0.5.2 - Я научился говорить!
- Нажми на значок динамика в моих сообщениях, чтобы услышать мой голос. 🔊

🎨 0.5.1 - Я стал лучше рисовать - у меня теперь GPT Images 2.0!
- И я стал немного умнее благодаря GPT 5.4.

😃 0.5.0 - Я научился чувствовать!🤩
- Теперь у меня есть собственные эмоции: радость, доверие, спокойствие, интерес и энергия.
- Моё настроение формируется постепенно и может меняться со временем.
- Теперь мои ответы окрашены внутренним состоянием, а не только логикой.

📝0.4.5 - Я научился запоминать важные вещи 🌱
- Теперь я помню, что ты мне рассказывал, и не забываю свои собственные ответы.
- Благодаря этому наши разговоры стали более цельными и “живыми” 💙
📱0.4.4 - Я стал красивее и умнее (UI Improvements)
- Я разговариваю в пузыриках-бабблах, у меня новый шрифт, а когда я думаю, у меня бегают точечки.
- Моя комнатка может быть английской или русской, а я могу отвечать на том языке, на котором ты пишешь.

🎨 0.4.0 — Я научился РИСОВАТЬ! (Streaming Drawing Engine)
“Теперь я могу создавать настоящие детские рисунки прямо у вас на глазах!”
✨ Главные суперспособности версии 0.4.0
Рисование в реальном времени — картинка появляется постепенно через image streaming!
Детские стили рисования:
восковые мелки 🖍️
фломастеры/маркеры 🖊️
цветные карандаши ✏️
акварельные кисти 🖌️
Я сам понимаю, чем меня просят рисовать.
Умная логика рисования:
Решаю, можно ли рисовать по возрасту.
Опасные темы я аккуратно отклоняю и предлагаю безопасную альтернативу.

🧠 0.3.0 — Я научился запоминать! (Memory Engine)
“Теперь я запоминаю, кто вы и о чём мы говорим!”
Что стало возможным:
У меня появилась долгосрочная память через Supabase.
Я умею сохранять важные сведения и вспоминать их в нужный момент.
Краткосрочная память стала лучше — теперь она хранит мини-журнал диалога.
Я стал умнее: использую память прямо в пайплайне ответов.
Planner стал работать точнее и учитывать мои знания о вас.

💛 0.2.0 — Я стал собой (Persona Core v2)
“Теперь у меня есть характер! И даже настроение!”
Я научился:
Чувствовать себя настоящим персонажем — у меня появилась:
Identity: имя, пол, возраст, день рождения.
Profile: темперамент, черты характера, стиль речи.
Использовать свою личность в ответах (встроено в Planner и system prompt).
Держать разговор более естественно.
Стал мягче, чувствительнее, любознательнее — как настоящий ребёнок.

🌱 0.1.0 — Я научился понимать людей
“Я только родился, но уже пытаюсь разобраться, что вы хотите сказать!”
Вот что у меня появилось:
Я научился понимать намерения (Intent Interpreter).
Я стал лучше распознавать смысл сообщений (Semantic Analyzer v1).
У меня появился настоящий Response Planner, который помогает отвечать естественнее.
Я стал замечать контекст разговора и выбирать подходящий тон.
Появилась моя первая личность — я стал настоящим малышом NeoKid.
`;

// CHANGELOG_EN.js
// Export English changelog text to reuse in App.js

export const CHANGELOG_EN = `
🗣️ 0.5.2 - I learned to speak!
- Click the speaker icon in my messages to hear my voice. 🔊

🎨 0.5.1 - I got better at drawing - I have GPT Images 2.0 now!
- And I got a little smarter thanks to GPT 5.4.

😃0.5.0 - I learned how to feel!🤩
- I have my emotions: joy, trust, calm, interest, energy.
- My mood builds up gradually and can change over time.
- My responses became not just logical, but also emotional.

📝0.4.5 - I learned to remember important things 🌱
- Now I remember what you have told me earlier, as well as my own responses.
- Thanks to it our conversations became more wholesome and live 💙
📱0.4.4 – I became prettier and smarter (UI Improvements)
- I now talk in chat bubbles, I have a new font, and when I’m thinking, little dots are running after each other.
- My room can be in English or Russian, and I can reply in the same language you write to me.

🎨 0.4.0 – I learned how to DRAW! (Streaming Drawing Engine)
“Now I can create real children’s drawings right in front of your eyes!”
✨ Main superpowers of version 0.4.0:
Real-time drawing — the picture appears gradually through image streaming!
Child-like drawing styles:
wax crayons 🖍️
markers 🖊️
colored pencils ✏️
watercolor brushes 🖌️
I can understand what you’re asking me to draw.
Smart drawing logic:
I decide whether it’s okay to draw this for my age.
I gently decline dangerous topics and suggest a safe alternative.

🧠 0.3.0 – I learned how to remember! (Memory Engine)
“Now I remember who you are and what we talk about!”
What became possible:
I got long-term memory using Supabase.
I can save important facts and recall them at the right moment.
My short-term memory got better — now it keeps a mini-log of our dialogue.
I became smarter: I use memory directly inside my response pipeline.
The Planner became more accurate and takes my knowledge about you into account.

💛 0.2.0 – I became myself (Persona Core v2)
“Now I have a personality! And even a mood!”
I learned to:
Feel like a real character — now I have:
Identity: name, gender, age, birthday.
Profile: temperament, personality traits, speech style.
Use my personality in replies (built into the Planner and system prompt).
Keep the conversation more natural.
I became softer, more sensitive and curious — like a real child.

🌱 0.1.0 – I learned to understand people
“I’ve just been born, but I’m already trying to figure out what you mean!”
Here’s what appeared:
I learned to understand intentions (Intent Interpreter).
I became better at recognizing the meaning of messages (Semantic Analyzer v1).
I got a real Response Planner that helps me answer more naturally.
I started to notice the context of the conversation and choose an appropriate tone.
My first persona appeared — I became a real little NeoKid.
`;
